import React from "react";
import PropTypes from "prop-types";
export function MailIcon({ color = "#39589b", width = 21, height = 21 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14">
      <g fill="none" fillRule="evenodd">
        <path d="M-3-5h24v24H-3z" />
        <path
          fill="#0771F7"
          d="M17.648 4.965c.07-.07.147-.082.229-.035a.228.228 0 0 1 .123.21v7.173c0 .468-.164.867-.492 1.195a1.627 1.627 0 0 1-1.196.492H1.687c-.468 0-.867-.164-1.195-.492A1.627 1.627 0 0 1 0 12.313V5.14c0-.094.041-.159.123-.194a.227.227 0 0 1 .229.018c.773.586 2.578 1.91 5.414 3.973l.351.316c.563.422 1.008.726 1.336.914.563.305 1.078.457 1.547.457.469 0 .984-.164 1.547-.492.351-.188.797-.492 1.336-.914l.351-.281C15 6.945 16.804 5.62 17.648 4.965zM9 9.5c-.305 0-.68-.14-1.125-.422-.258-.14-.621-.398-1.09-.773l-.351-.246C3.55 5.949 1.594 4.496.562 3.699l-.246-.176A.801.801 0 0 1 0 2.855v-.667c0-.47.164-.868.492-1.196A1.627 1.627 0 0 1 1.687.5h14.625c.47 0 .868.164 1.196.492.328.328.492.727.492 1.196v.667a.801.801 0 0 1-.316.668l-.176.141c-1.008.797-2.989 2.262-5.942 4.395l-.351.246c-.469.375-.832.633-1.09.773C9.68 9.36 9.305 9.5 9 9.5z"
        />
      </g>
    </svg>
  );
}
MailIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};
